<div class="form-group row" [ngClass]="{invalid: field?.invalid}">
	<label
		class="col-form-label font-weight-bold {{options?.label?.class ? options?.label?.class:'col-sm-3'}}">
		{{options?.label?.text}}
	</label>
	<div class="{{options?.class ? options?.class:'col-sm-9'}}" [ngSwitch]="type">
		<input *ngSwitchCase="'input'" type="text" class="form-control"
			placeholder="{{options?.placeholder}}"
			[formControl]="field">
		<input *ngSwitchCase="'email'" type="email" class="form-control"
			placeholder="{{options?.placeholder}}"
			[formControl]="field" autocomplete="off">
		<div class="input-group" *ngSwitchCase="'password'">
			<input
				[type]="showPassword ? 'text' : 'password'"
				class="form-control"
				placeholder="{{options?.placeholder}}"
				[formControl]="field"
				autocomplete="off"
			>
			<button type="button" class="btn btn-outline-secondary" (click)="togglePassword()">
				<i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
			</button>
		</div>

		<textarea *ngSwitchCase="'textarea'" class="form-control"
			[formControl]="field" rows="{{options.rows}}">
        </textarea>

		<div *ngSwitchCase="'select'">
			<select *ngIf="!isMulti"
				class="form-control"
				[formControl]="field">
				<option [ngValue]="null">{{options?.dropdown.text}}</option>
				<option *ngFor="let option of options?.dropdown.options"
					[ngValue]="options?.dropdown.optionsValueField ? option[options?.dropdown.optionsValueField] : option.id"
					[selected]="field.value === (options?.dropdown.optionsValueField ? option[options?.dropdown.optionsValueField] : option.id)">

					{{options?.dropdown.optionsLabelField ? option[options?.dropdown.optionsLabelField] : option.name}}
				</option>
			</select>

			<select *ngIf="isMulti"
				class="form-control"
				multiple
				[formControl]="field"
				[ngClass]="{ multi: isMulti }">
				<option *ngFor="let option of options?.dropdown.options"
					[ngValue]="options?.dropdown.optionsValueField ? option[options?.dropdown.optionsValueField] : option.id"
					[selected]="field.value === (options?.dropdown.optionsValueField ? option[options?.dropdown.optionsValueField] : option.id)">

					{{options?.dropdown.optionsLabelField ? option[options?.dropdown.optionsLabelField] : option.name}}
				</option>
			</select>
		</div>

		<label *ngSwitchCase="'switch'" class="switch switch-label switch-pill switch-primary">
			<input type="checkbox" [formControl]="field" class="switch-input" [checked]="isChecked">
			<span class="switch-slider" [attr.data-checked]="options.switchers.trueCaption || 'Activo'"
				[attr.data-unchecked]="options.switchers.falseCaption || 'Inactivo'">
			</span>
		</label>

		<!-- <input *ngSwitchCase="'search'" [ngbTypeahead]="search" type="text" class="form-control"> -->
		<div *ngSwitchCase="'image'">
			<div class="avatar-upload" [ngClass]="options?.image?.class">
				<div class="avatar-edit">
					<input type='file' id="imageUpload-{{options?.path}}"
						(change)="readFile($event)"
						multiple="multiple" accept=".png, .jpg, .jpeg" />
					<label for="imageUpload-{{options?.path}}"></label>
				</div>
				<div class="avatar-preview">
					<div id="imagePreview" [style.background-image]="bgStyle()">
					</div>
				</div>
				<br>
				<div *ngIf="options?.image?.selectPhotoButton">
					<label for="imageUpload-{{options?.path}}"
						class="btn btn-block {{options.image.selectPhotoButton?.class ? options.image.selectPhotoButton.class: 'btn-primary'}}">
						{{options.image.selectPhotoButton.text}}
					</label>
				</div>
			</div>
		</div>

		<div *ngSwitchCase="'media'">
			<p-fileUpload #fileUploadComponent accept="{{options?.allowedTypes}}"
				chooseLabel="Selecciona un archivo"
				[customUpload]="true" [showCancelButton]="false" [showUploadButton]="false" [maxFileSize]="104857600"
				(onSelect)="onResourceMediaSelect($event, fileUploadComponent)"
				(onSizeLimit)="onFileSizeLimit($event)">

				<ng-template let-file pTemplate="file">
					<div class="p-fileUpload-row">
						<div *ngIf="isVideo">
							<div class="container-video">
								<video [src]="videoSrc" controls>

								</video>
							</div>
						</div>
						<div *ngIf="!isVideo" class="container-image"><img [src]="file.objectURL"
								width="50" /></div>
						<div class="custom-filename"> {{file.name}} </div>
						<div> {{file.size}} bytes</div>
						<div>
							<p-button (click)="removeFile(fileUploadComponent)"
								icon="pi pi-times"></p-button>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="content">
					<ul *ngIf="mediaResources.length">
						<li *ngFor="let file of mediaResources">
							{{ file.name }} - {{ file.size }} bytes
						</li>
					</ul>
				</ng-template>
			</p-fileUpload>

			<div class="text-danger mt-2" *ngIf="sizeLimitMessage">{{ sizeLimitMessage }}</div>
		</div>

		<div *ngSwitchCase="'datepicker'">
			<input [formControl]="field" class="form-control"
				placeholder="{{options?.placeholder}}" bsDatepicker
				[bsConfig]="datePicker" (bsValueChange)="onDateChange($event)">
		</div>
		<ace-editor *ngSwitchCase="'json_editor'" [formControl]="field"
			[mode]="'json'" #editor class="ace-editor"></ace-editor>
		<p-multiSelect
			*ngSwitchCase="'multiselect'" [options]="options?.options || []"
			[formControl]="field" display="chip"
			optionLabel="name" optionValue="id" placeholder="Selecciona..."
			[showClear]="true" class="w-100 custom-multiselect">
		</p-multiSelect>

		<ng-container *ngSwitchCase="'radio_button'">
			<div *ngFor="let option of options?.dropdown.options" class="field-checkbox">
				<p-radioButton [inputId]="option" name="option" [value]="option"
					[formControl]="field"></p-radioButton>
				<label [for]="option">{{option}}</label>
			</div>
		</ng-container>
	</div>
